import { Body, Icon, IconButton } from '@assembly-js/design-system';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

type FilterDropdownAction = {
  name: string;
  onClick: () => void;
  showIcon: boolean;
};
interface FilterDropdownProps {
  actions: FilterDropdownAction[];
}
export const FilterDropdown: React.FC<FilterDropdownProps> = ({ actions }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <div>
      <IconButton
        icon="Filter"
        variant="minimal"
        size="sm"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      />
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={() => setAnchorEl(null)}
      >
        {actions.map((action, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              action.onClick();
              setAnchorEl(null);
            }}
            className="min-h-[35.5px]"
          >
            <ListItemIcon
              classes={{
                root: '!min-w-max !w-4 !h-4 mr-2 text-black-heading',
              }}
            >
              {action.showIcon && <Icon icon="Check" className="h-4 w-4" />}
            </ListItemIcon>
            <ListItemText>
              <Body size="sm">{action.name}</Body>
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
